import { IRole } from "../interfaces/IRole";
import { ApiService } from "./apiService";

export const getRoles = async (): Promise<IRole[]> => {
	return (await ApiService.retryGet(`${process.env.REACT_APP_API_URL}/api/roles`)).data;
};
